import { Injectable, SimpleChanges } from '@angular/core';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { Cargochief } from '@service/cargochief/cargochief.service';
import { SegmentWrapperService } from '@service/segmentWrapper/segment-wrapper.service';
import { UtilService } from '@service/util/util.service';
import { IS_NOT_EMPTY, IS_NOT_NULL_OR_UNDEFINED, IS_NULL_OR_UNDEFINED } from 'cargo-chief-commons';

@Injectable()
export class PricingHelperService {
	constructor(
		private utilService: UtilService,
		private cargochief: Cargochief,
		private segmentWrapper: SegmentWrapperService
	) {}

	emailSentSuccessfully() {
		this.utilService.showSnackbar(
			'You are on the list! You will receive an email confirmation along with some follow up information.',
			SNACKBAR.SUCCESS,
			SNACKBAR.ACTION
		);
	}

	fireSegmentEvent(eventName: string) {
		const eventProperties = {
			user: this.cargochief.getUser(),
		};
		this.segmentWrapper.fireSegmentEvent(eventName, eventProperties);
	}

	hasSearchChanged(previousSearch, currentSearch): boolean {
		let result = false;
		if (IS_NULL_OR_UNDEFINED(previousSearch) || IS_NULL_OR_UNDEFINED(currentSearch)) {
			result = true;
		} else {
			if (
				previousSearch['origin']['city'] !== currentSearch['origin']['city'] ||
				previousSearch['origin']['state'] !== currentSearch['origin']['state'] ||
				previousSearch['origin']['zip'] !== currentSearch['origin']['zip'] ||
				previousSearch['destination']['city'] !== currentSearch['destination']['city'] ||
				previousSearch['destination']['state'] !== currentSearch['destination']['state'] ||
				previousSearch['destination']['zip'] !== currentSearch['destination']['zip'] ||
				previousSearch['trailerType'] !== currentSearch['trailerType'] ||
				previousSearch['pickupDateStart'] !== currentSearch['pickupDateStart'] ||
				previousSearch['pickupDateEnd'] !== currentSearch['pickupDateEnd'] ||
				previousSearch['hazmat'] !== currentSearch['hazmat']
			) {
				result = true;
			}
		}
		return result;
	}

	isCitySelected(currentSearch: Object): boolean {
		return (
			IS_NOT_EMPTY(currentSearch['origin']['city']) &&
			IS_NOT_EMPTY(currentSearch['destination']['city'])
		);
	}

	greenScreensEnabledValueChanged(changes: SimpleChanges): boolean {
		const previousValue = changes?.greenScreensEnabled?.previousValue;
		const currentValue = changes?.greenScreensEnabled?.currentValue;
		return (
			IS_NOT_NULL_OR_UNDEFINED(previousValue) &&
			IS_NOT_NULL_OR_UNDEFINED(currentValue) &&
			previousValue != currentValue
		);
	}

	retainSingleEquipment(searchTruckForm: any) {
		return {
			...searchTruckForm,
			trailerType: searchTruckForm['trailerType'].split(',')[0],
		};
	}
}
